const PHRASES = [
  "Seasonal Ingredients",
  "Michelin Technique",
  "Private Dining",
  "Bespoke Menu Artistry",
  "Weddings & Galas",
  "Architectural Plating",
];

export const Marquee = () => {
  const strip = (
    <>
      {PHRASES.map((p) => (
        <span key={p} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-noir/45 sm:text-3xl">
            {p}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-gold/70" aria-hidden="true" />
        </span>
      ))}
    </>
  );

  return (
    <section
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-noir/10 bg-linen py-7"
    >
      <div className="marquee-track flex w-max">
        <div className="flex">{strip}</div>
        <div className="flex">{strip}</div>
      </div>
    </section>
  );
};
